const awsconfig =  {
  identityPoolId : process.env.VUE_APP_IDENTITY_POOL_ID,
  region: process.env.VUE_APP_REGION,
  userPoolId: process.env.VUE_APP_COGNITO_USERPOOL_ID,
  userPoolWebClientId: process.env.VUE_APP_CLIENT_ID,
};

export default awsconfig;
